import { SET_SOCKET_CONNECTING, SET_SOCKET_IO_CLIENT, SET_SOCKET_PRINTER_DESKTOP_SESSIONS, SET_SOCKET_RECONNECTED, SET_SOCKET_VOIP_DESKTOP_SESSIONS } from '../../actionTypes/socket'

export const setSocketIoClient = value => ({ type: SET_SOCKET_IO_CLIENT, value })

export const setSocketConnecting = value => ({ type: SET_SOCKET_CONNECTING, value })

export const setSocketReconnected = value => ({ type: SET_SOCKET_RECONNECTED, value })

export const setSocketPrinterDesktopSessions = value => ({ type: SET_SOCKET_PRINTER_DESKTOP_SESSIONS, value })

export const setSocketVoipDesktopSessions = value => ({ type: SET_SOCKET_VOIP_DESKTOP_SESSIONS, value })
